<template>
  <div>
    <v-footer
      padless
      class="px-5 white"
      color="light"
      style="margin-bottom: 70px"
    >

      <v-row v-if="show_details" class="container-cono">
        <v-col cols="12" class="text-center">
          <img class="cono-footer" src="@/assets/store/home/cono.png" alt="">
        </v-col>
      </v-row>

      <div class="row">
        <div class="col-md-6 col-sm-8 col-xs-8 col-8">
          <img class="h2o" src="@/assets/store/home/h2o.png" alt=""> <br>
          <!--
          <img
            class="powered_by_google mb-1"
            src="@/assets/store/powered_by_google.png" alt=""
          > <br> -->
          <span class="color-blue font-general-r text-footer-mobile">
            © Copyright Nievedeolla 2020
          </span>
          <div v-if="show_details" class="flex">
            <img class="footer-brand" src="@/assets/store/home/amex.png" alt="">
            <img class="footer-brand" src="@/assets/store/home/crypto1.png" alt="">
            <img class="footer-brand" src="@/assets/store/home/crypto2.png" alt="">
            <img class="footer-brand" src="@/assets/store/home/crypto3.png" alt="">
            <img class="footer-brand" src="@/assets/store/home/mastercard.png" alt="">
            <img class="footer-brand" src="@/assets/store/home/paypal.png" alt="">
            <img class="footer-brand" src="@/assets/store/home/visa.png" alt="">
          </div>
          <div class="text-left mr-10 mt-5 text-footer-mobile color-blue font-general-r">
            <span>hola@nievedeolla.com</span> <br>
            <span>+52 55 7947 2295</span> <br>
            <span>
              Alfonso Reyes 122, Colonia Condesa, Cuauhtémoc, C.P 06170, CDMX
            </span>
            <span>
              Casa Basalta - Colima 159, Roma norte, Cuauhtémoc, 06700, CDMX
            </span>
          </div>
        </div>
        <div v-if="show_details" class="col-md-6 col-sm-4 col-xs-4 col-4">
          <div class="text-right">
            <a href="https://www.instagram.com/nievedeolla/" target="_blank">
              <img class="footer-redes mb-3" src="@/assets/store/home/ig.png" alt="">
            </a>
            <a href="https://www.facebook.com/NieveDeOlla" target="_blank">
              <img class="footer-redes mb-3" src="@/assets/store/home/fb.png" alt="">
            </a> <br>
            <span class="color-blue font-general-r text-footer-mobile">Heladería mexicana</span>

          </div>
        </div>
      </div>

    </v-footer>

    <v-speed-dial
      v-if="show_details"
      v-model="fab"
      direction="top"
      bottom
      right
      absolute
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-tooltip color="primary" dark left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              v-model="fab"
              color="primary"
              dark
              fab
              elevation="0"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon v-if="fab">
                mdi-close
              </v-icon>
              <v-icon v-else>
                mdi-whatsapp
              </v-icon>
            </v-btn>
          </template>
          <span class="font-general-r">¡Hola!, ¿Cómo podemos ayudarte?</span>
        </v-tooltip>

      </template>
      <v-btn
        style="outline:none !important"
        fab
        dark
        small
        color="primary"
        target="_blank"
        href="https://www.google.com/maps/place/Nieve+de+Olla/@19.4090857,-99.1770353,15z/data=!4m2!3m1!1s0x0:0x115a1e39b117dc00?sa=X&ved=2ahUKEwiHkLGp78LtAhXSzVkKHZGLCI8Q_BIwFnoECCYQBQ"
      >
        <v-icon>mdi-map-marker</v-icon>
      </v-btn>
      <v-btn
        style="outline:none !important"
        fab
        small
        dark
        color="primary"
        @click="open_modal_phone = true"
      >
        <v-icon>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        style="outline:none !important"
        fab
        dark
        small
        color="primary"
        target="_blank"
        href="https://wa.me/525579472295"
      >
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
    </v-speed-dial>

  </div>
</template>

<script>
export default {
  props: {
    show_details: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      fab: false
    }
  }
}
</script>
